export default __webpack_public_path__ + "static/web_portal_banner-a7aa7d4fb0c716a32cb9b72d92683c92.webp";